/**
 * Smoothed frame timing + render info snapshot.
 */
export class PerformanceMonitor {
  constructor() {
    this.fps = 0;
    this.frameMs = 0;
    this._accum = 0;
    this._frames = 0;
    this._lastSample = performance.now();

    /** @type {import('three').WebGLRenderer | null} */
    this._renderer = null;

    this.drawCalls = 0;
    this.triangles = 0;
    this.geometries = 0;
    this.textures = 0;
  }

  /** @param {import('three').WebGLRenderer} renderer */
  attachRenderer(renderer) {
    this._renderer = renderer;
    renderer.info.autoReset = false;
  }

  /** @param {number} deltaSeconds */
  tick(deltaSeconds) {
    this._accum += deltaSeconds;
    this._frames += 1;
    this.frameMs = deltaSeconds * 1000;

    const now = performance.now();
    if (now - this._lastSample >= 500) {
      this.fps = Math.round(this._frames / this._accum);
      this._accum = 0;
      this._frames = 0;
      this._lastSample = now;
    }
  }

  /** Call once per frame after rendering. */
  sampleRenderInfo() {
    if (!this._renderer) return;
    const info = this._renderer.info;
    this.drawCalls = info.render.calls;
    this.triangles = info.render.triangles;
    this.geometries = info.memory.geometries;
    this.textures = info.memory.textures;
    info.reset();
  }
}
